import React from "react";
import { FaClock } from "react-icons/fa";
import "./ProgramLifecycleBadge.css";

/**
 * ProgramLifecycleBadge — pill rendered next to the program name so
 * lifecycle state is legible at-a-glance (Zuri visual spec §1.3). Story 1
 * ships `active` (default — no badge rendered), `suspended` (amber pill
 * with clock icon), and `cancelled` (red-outline pill). Story 2 ships the
 * cancel-side wiring; the badge is defensive against the value already so
 * Story 2 doesn't require a badge-side change.
 *
 * Design choice: `active` renders NOTHING (no visual noise on the common
 * case — matches spec table §1.3). Any unknown lifecycleState value ALSO
 * renders nothing (defensive against BE schema drift; a new state landing
 * on the wire does not break the page — it just doesn't paint until FE
 * catches up).
 */
const ProgramLifecycleBadge = ({ lifecycleState }) => {
  if (!lifecycleState || lifecycleState === "active") {
    return null;
  }

  if (lifecycleState === "suspended") {
    return (
      <span
        className="program-lifecycle-badge is-suspended"
        data-testid="program-lifecycle-badge"
        aria-label="Program suspended"
      >
        <FaClock aria-hidden="true" />
        <span>Suspended</span>
      </span>
    );
  }

  if (lifecycleState === "cancelled") {
    return (
      <span
        className="program-lifecycle-badge is-cancelled"
        data-testid="program-lifecycle-badge"
        aria-label="Program cancelled"
      >
        Cancelled
      </span>
    );
  }

  return null;
};

export default ProgramLifecycleBadge;
